import EventMapContainer from './event_map_container';

const EventMap = EventMapContainer;
export default EventMap;
